require('./provinces-list-container.scss')

module.exports = {
  template: require('./provinces-list-container.pug')()
  controller: require('./provinces-list-container.ctrl')
  bindings:
    country: '<'
    city: '<'
}
